import { useState } from 'react';
import { useSelector } from 'react-redux';
import ChatsListMobile from './ChatsListMobile';
import ProfileFull from '../Profile/ProfileFull';

/**
 * ChatsListDesktop - Desktop view for chats with sidebar list and main content area
 * Similar to Facebook Messenger UI
 * Left: Chats list (ChatsListMobile)
 * Right: ProfileFull with chat tab selected
 */
function ChatsListDesktop() {
  const currentUserId = useSelector((s) => s.user.authUserId);
  const chats = useSelector((s) => s.chats.chats);
  
  // Local state for selected chat
  const [selectedChatId, setSelectedChatId] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState(null);

  // Handle chat selection
  const handleChatSelect = (chat) => {
    setSelectedChatId(chat.id);
    // Find the other user in the chat (not current user)
    const otherUserId = chat.user_ids?.find(id => id !== currentUserId);
    setSelectedUserId(otherUserId);
  };

  return (
    <div className="flex h-full">
      {/* Left sidebar - Chats list */}
      <div className="w-80 border-r border-border flex-shrink-0">
        <ChatsListMobile onChatSelect={handleChatSelect} />
      </div>

      {/* Right side - ProfileFull with chat tab */}
      <div className="flex-1 overflow-hidden h-full">
        {selectedUserId ? (
          <ProfileFull id={selectedUserId} initialTab="chat" />
        ) : (
          <div className="flex h-full items-center justify-center text-muted-foreground">
            Select a conversation to start chatting
          </div>
        )}
      </div>
    </div>
  );
}

export default ChatsListDesktop;
